import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { IconEye, IconEyeOff } from '../components/icons';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(identifier, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-box" onSubmit={submit}>
        <div className="login-logo">
          <div className="logo-mark">S</div>
          <div className="login-brand">SAANTI MASSAGE</div>
          <div className="login-sub">BY THAI·HAND</div>
        </div>

        {error && <div className="login-error">{error}</div>}

        <input
          className="login-input"
          placeholder="เบอร์โทร / Email / User ID"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          autoComplete="username"
          autoFocus
        />

        <div style={{ position: 'relative' }}>
          <input
            className="login-input"
            type={showPassword ? 'text' : 'password'}
            placeholder="รหัสผ่าน"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            aria-label={showPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'}
            style={{ position: 'absolute', right: 6, top: 8 }}
            onClick={() => setShowPassword((s) => !s)}
          >
            {showPassword ? <IconEyeOff size={19} /> : <IconEye size={19} />}
          </button>
        </div>

        <button className="login-submit" type="submit" disabled={busy}>
          {busy ? 'กำลังเข้าสู่ระบบ…' : 'เข้าสู่ระบบ'}
        </button>
      </form>
    </div>
  );
}
